import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "antd";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import GeneralDetails from "../Components/GeneralDetails";
import ProgressModal from "../../../App/Utils/ProgressModal";
import PackageDetails from "../Components/PackageDetails";
import DeliveryDetails from "../Components/DeliveryDetails";
import OtherDetails from "../Components/OtherDetails";
import { DataProvider } from "../../DataProvider";

const NewPackage = ({ history }) => {
    const dataProvider = new DataProvider();
    const formRef = useRef();
    const [form] = Form.useForm();
    const [showProgress, setShowProgress] = useState(false);
    
    useEffect(() => { }, [showProgress])

    const onFinish = (values) => {
        setShowProgress(true);
        const formData = new FormData()
        const supplierDetails = JSON.parse(values['supplier'])
        values['supplier'] = supplierDetails['key']
        values['packing_list'].forEach((item, i)=>{
            formData.append('packing_list-'+i, item.originFileObj)
        })
        formData.append('data', JSON.stringify(values))
        dataProvider.submitPackage(formData)
            .then(response => {
                setShowProgress(false);
                if (response.ok) {
                    response.json().then(responseJson => {
                        openNotification("success", "Success", responseJson["message"])
                        history.replace('/PROCUREMENT/ViewPackage/' + responseJson['id'])
                    })
                } else {
                    response.json().then(responseJson => {
                        openNotification("error", "Error", responseJson["message"])
                    })
                }
            }).catch(error => {
                openNotification("error", "Error", "Error connecting server")
                setShowProgress(false);
            })
    };

    return (
        <>
            <ProgressModal showProgress={showProgress} />
            <Form
                ref={formRef}
                className="ant-form ant-form-vertical"
                onFinish={onFinish}
                scrollToFirstError={true}
                form={form}
                encType="multipart/form-data"
            >
                <div className="row form-box" style={{paddingTop:"10px"}}>
                    <GeneralDetails formRef={formRef} />
                </div>
                <div className="row form-box" >
                    <legend className="form-legend">Package Details</legend>
                    <PackageDetails formRef={formRef} />
                </div>
                <div className="row form-box" style={{paddingTop:"10px"}}>
                    <OtherDetails formRef={formRef} />
                </div>
                {/* <div className="row form-box" >
                    <legend className="form-legend">Delivery Details</legend>
                    <DeliveryDetails formRef={formRef} />
                </div> */}
                <div style={{ textAlign: "right", marginRight: "15px" }}>
                    <Button
                        htmlType="submit"
                        type="primary">Submit
                    </Button>
                </div>
            </Form>
        </>
    );
};

export default NewPackage;